import * as angular from 'angular';
import * as _ from 'lodash';

import { StateProvider, UrlRouterProvider } from '@uirouter/angularjs';
import * as services from './services.index';
import * as components from './components.index';
import { registerComponents, registerServiceId } from '../registration.helper';
import * as States from './states.index';

export const statesModuleName = 'wt-states';

const config = ['$stateProvider', '$urlRouterProvider',
    ($stateProvider: StateProvider, $urlRouterProvider: UrlRouterProvider) => {

        // Moved on top as below states, redirect doesn't
        $urlRouterProvider
            .when('/qualityAnalysis', '/qualityAnalysis/overview')
            .when('/moreTools', '/moreTools/connectionPoints');

        for (const key of Object.keys(States)) {
            States[key].forEach(s => $stateProvider.state(s));
        }
    }];

const module = angular.module(statesModuleName, ['ui.router']);
registerServiceId(services, module).config(config);
registerComponents(components, module);